import React from 'react';

interface LoadingOverlayProps {
  show: boolean;
}

// ===== Composant LoadingOverlay =====
const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ show }) => {
  if (!show) return null;

  return (
    <div className="loading-overlay">
      <div className="bg-white rounded-lg p-6 flex items-center space-x-4">
        <div className="loading-spinner"></div>
        <span className="text-gray-700 font-medium">Chargement...</span>
      </div>
    </div>
  );
};

export default LoadingOverlay;
